<template>
    <div v-if="options.length > 0">
        <p class="bsdc-config-filters__label">
            {{ label }}

            <Tooltip :text="tooltip" />

            <slot name="label" />
        </p>

        <div class="bsdc:flex gap-2">
            <label
                v-for="(option, index) in options"
                :key="index"
                :for="`${name}-filter-${option.value}`"
                class="bsdc-config-selector__item"
                :class="{ active: option.value == selectedOption }"
            >
                <img
                    v-if="pluginUrl && iconPrefix"
                    width="20"
                    height="20"
                    :src="`${pluginUrl}assets/img/icons/${iconPrefix}${option.value}.svg`"
                    :alt="`${option.label} icon`"
                />

                {{ option.label }}

                <input
                    :id="`${name}-filter-${option.value}`"
                    type="radio"
                    :value="option.value"
                    :checked="option.value == selectedOption"
                    @change="emit('update:selectedOption', option.value)"
                />
            </label>
        </div>
    </div>
</template>

<script setup>
    import { ref } from "vue";

    import Tooltip from "@js/Components/Tooltip.vue";

    defineProps({
        label: String,
        name: String,
        iconPrefix: String,
        tooltip: String,
        options: Array,
        selectedOption: [
            String,
            Number,
        ],
    });

    const emit = defineEmits(['update:selectedOption']);

    const pluginUrl = ref(BSDC.pluginUrl);
</script>

<style>
    @reference "../../css/app.css";

    .bsdc-config-selector__item {
        img {
            @apply bsdc:w-5 bsdc:max-h-5;
        }
    }
</style>
